import {
    Row, Col, Card, Table, Button, Input, Tag,
    Tooltip, Avatar, Image, Space, Select, Modal,
} from "antd";
import React, { useState, useContext, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";
import { useNavigate } from "react-router";
import ShowTotal from "../../components/ShowTotal";
import apiPath from "../../constants/apiPath";
import { UserStatus } from "../../constants/conts";
import { UndoOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import FilterBar, { FilterBarFilters } from "../../components/FilterBar";
import confirm from "antd/lib/modal/confirm";

const Search = Input.Search;

function Coach() {
    const { Option } = Select;
    const sectionName = "Coach";
    const [searchText, setSearchText] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [selectedUser, setSelectedUser] = useState();
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [filters, setFilters] = useState({
        status: undefined,
        isVerified: undefined,
    });

    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const debouncedSearchText = useDebounce(searchText, 300);
    const navigate = useNavigate();

    const view = (id) => navigate(`/admin/user-manager/view/${id}`);

    const fetchData = (paginationParam, filtersParam) => {
        setLoading(true);
        const params = new URLSearchParams();

        params.append("isCoach", "true");

        if (debouncedSearchText) {
            params.append("search", debouncedSearchText);
        }

        if (filtersParam?.status) {
            params.append("status", filtersParam.status);
        }

        if (filtersParam?.isVerified !== undefined && filtersParam?.isVerified !== null && filtersParam?.isVerified !== "all") {
            params.append("isVerified", filtersParam.isVerified);
        }

        params.append("page", paginationParam.current);
        params.append("limit", paginationParam.pageSize);

        request({
            url: `${apiPath.coachAcademyList}?${params.toString()}`,
            method: "GET",
            onSuccess: ({ data }) => {
                setLoading(false);
                setList(data?.data || []);
                setPagination({
                    current: Number(data?.page) || paginationParam.current,
                    total: Number(data?.total) || 0,
                    pageSize: Number(data?.limit) || paginationParam.pageSize,
                });
            },
            onError: (error) => {
                setLoading(false);
                ShowToast(error, Severty.ERROR);
            },
        });
    };

    const handleOpenStatus = (id, currentStatus) => {
        setSelectedUser({ id, status: currentStatus });
        setStatusModalOpen(true);
    };

    const handleStatus = (id, status) => {
        request({
            url: `${apiPath.changeUserStatus}/${id}`,
            method: "PUT",
            data: { status },
            onSuccess: (data) => {
                setStatusModalOpen(false);
                fetchData(pagination, filters);
                ShowToast(
                    `${data.message || "Status Changed Successfully"}`,
                    Severty.SUCCESS,
                );
            },
            onError: (err) => {
                ShowToast(err, Severty.ERROR);
            }
        });
    };

    const handleFilterChange = (filterName, value) => {
        const updatedFilters = { ...filters, [filterName]: value };
        setFilters(updatedFilters);
        const resetPagination = { ...pagination, current: 1 };
        fetchData(resetPagination, updatedFilters);
    };

    const handleReset = () => {
        setFilters({
            status: undefined,
            isVerified: undefined,
        });
        setSearchText("");
        const resetPagination = { ...pagination, current: 1 };
        fetchData(resetPagination, { status: undefined, isVerified: undefined });
    };
    const confirmVerification = (id, currentIsVerified) => {
        setTimeout(() => {
            confirm({
                maskClosable: true,
                icon: <ExclamationCircleOutlined />,
                className: "tab_modal",
                cancelButtonProps: { color: "red" },
                content: (
                    <p
                        style={{
                            fontSize: "24px",
                            fontWeight: "bold",
                            textAlign: "center",
                        }}
                    >
                        Are you sure you want to change the verification status?
                    </p>
                ),
                onOk() {
                    setLoading(true);
                    request({
                        url: `${apiPath.verifyCoachAcademy}/${id}`,
                        method: "PUT",
                        data: { isVerified: !currentIsVerified },
                        onSuccess: (data) => {
                            setLoading(false);
                            fetchData(pagination, filters);
                            ShowToast(
                                `${data.message || "Verification status updated successfully"}`,
                                Severty.SUCCESS,
                            );
                        },
                        onError: (error) => {
                            setLoading(false);
                            ShowToast(error, Severty.ERROR);
                        },
                    });
                },
                onCancel() {
                    console.log("Cancel");
                },
            });
        }, 5);
    };

    const columns = [
        {
            title: "Name",
            key: "name",
            width: 240,
            render: (_, record) => {
                const profile = record.coachProfile;
                const fullName = profile?.fullName || record.name;
                const username = record.username;
                return (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {!record.avatar ? (
                            <Avatar size={40}>{fullName ? fullName.charAt(0).toUpperCase() : "N/A"}</Avatar>
                        ) : (
                            <Image className="image-index-radius" src={record.avatar} width={40} height={40} style={{ borderRadius: "50%" }} />
                        )}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <a onClick={() => view(record._id)} className="avatar-text column-avatar-text" style={{ fontWeight: 600, fontSize: "14px" }}>
                                {fullName || "-"}
                            </a>
                            <span style={{ fontSize: "12px", color: "#8c8c8c" }}>
                                @{username || "username"}
                            </span>
                        </div>
                    </div>
                );
            },
            sorter: (a, b) => {
                const nameA = a.coachProfile?.fullName || a.name;
                const nameB = b.coachProfile?.fullName || b.name;
                return nameA?.localeCompare(nameB);
            },
        },
        {
            title: "Mobile Number",
            key: "phone",
            width: 160,
            render: (_, record) => {
                const phone = record.coachProfile?.phoneNumber;
                const code = record.coachProfile?.countryCode;
                return `${code ? "+" + code + "-" : ""}${phone || "-"}`;
            },
        },
        {
            title: "Experience Level",
            key: "experienceLevel",
            width: 150,
            render: (_, record) => record.coachProfile?.experienceLevel || "-",
        },
        {
            title: "Fee Structure",
            key: "feeStructure",
            width: 180,
            render: (_, record) => {
                const profile = record.coachProfile;
                if (!profile?.feeStructure) return "-";
                const currency = profile.currency || "INR";
                return `${profile.feeStructure}${profile.feeAmount ? ` (${profile.feeAmount} ${currency})` : ""}`;
            },
        },
        {
            title: "Verification",
            key: "isVerified",
            width: 140,
            render: (_, record) => {
                const isVerified = record.coachProfile?.isVerified;
                return (
                    <a onClick={() => confirmVerification(record._id, isVerified)}>
                        <Tag style={{ cursor: "pointer" }} color={isVerified ? "green" : "orange"}>
                            {isVerified ? "Verified" : "Not Verified"}
                        </Tag>
                    </a>
                );
            },
        },
        {
            title: "Registered On",
            key: "createdAt",
            width: 150,
            render: (_, record) => {
                const regDate = record.coachProfile?.createdDate || record.createdAt;
                return regDate ? moment(regDate).format("DD-MM-YYYY") : "-";
            },
        },
        {
            title: "Action",
            key: "action",
            width: 100,
            render: (_, record) => (
                <Tooltip title={`View ${sectionName}`}>
                    <Button onClick={() => view(record._id)}>
                        <i className="fa fa-eye"></i>
                    </Button>
                </Tooltip>
            ),
        },
    ];

    const handleTableChange = (paginationParam) => {
        fetchData(paginationParam, filters);
    };

    useEffect(() => {
        fetchData(pagination, filters);
    }, [debouncedSearchText]);

    return (
        <>
            <div className="tabled customerMain" style={{ width: "100%" }}>
                <Row gutter={[24, 0]}>
                    <Col xs={24} style={{ width: "100%" }}>
                        <Card
                            title={`${sectionName} Manager`}
                            bordered={false}
                            extra={
                                <FilterBar
                                    searchContent={
                                        <Search
                                            allowClear
                                            placeholder={`Search by Name, Email, Username`}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            value={searchText}
                                            style={{ width: 300 }}
                                        />
                                    }
                                />
                            }
                        >
                            <FilterBarFilters>
                                <Select
                                    placeholder="Verification Status"
                                    value={filters.isVerified}
                                    allowClear
                                    onChange={(value) => handleFilterChange("isVerified", value)}
                                    style={{ width: 180 }}
                                >
                                    <Option value="all">All</Option>
                                    <Option value="true">Verified</Option>
                                    <Option value="false">Not Verified</Option>
                                </Select>

                                <Select
                                    placeholder="Status"
                                    value={filters.status}
                                    allowClear
                                    onChange={(value) => handleFilterChange("status", value)}
                                    style={{ width: 150 }}
                                >
                                    <Option value={UserStatus.ACTIVE}>Active</Option>
                                    <Option value={UserStatus.SUSPENDED}>Suspended</Option>
                                    <Option value={UserStatus.BANNED}>Banned</Option>
                                </Select>

                                <Button icon={<UndoOutlined />} onClick={handleReset}>
                                    Reset
                                </Button>
                            </FilterBarFilters>

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <h4 className="text-right m-0">
                                    {ShowTotal(pagination.total || 0)}
                                </h4>
                            </div>

                            <div className="table-responsive customPagination">
                                <Table
                                    loading={loading}
                                    columns={columns}
                                    dataSource={list}
                                    pagination={{
                                        current: pagination.current,
                                        pageSize: pagination.pageSize,
                                        total: pagination.total,
                                        showSizeChanger: true,
                                        pageSizeOptions: ["10", "20", "30", "50"],
                                    }}
                                    onChange={handleTableChange}
                                    rowKey="_id"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>

            {/* Status Update Modal */}
            <Modal
                open={statusModalOpen}
                footer={null}
                centered
                closable
                onCancel={() => setStatusModalOpen(false)}
            >
                <div style={{ textAlign: "center", padding: "10px 0" }}>
                    <p style={{ fontSize: 22, fontWeight: "bold", marginBottom: 20 }}>
                        Update Coach Status
                    </p>

                    <Space size="middle">
                        {selectedUser?.status !== "active" && (
                            <Button
                                type="primary"
                                style={{ background: "#52c41a", borderColor: "#52c41a" }}
                                onClick={() => handleStatus(selectedUser.id, "active")}
                            >
                                Active
                            </Button>
                        )}

                        {selectedUser?.status !== "suspended" && (
                            <Button
                                type="primary"
                                style={{ background: "#faad14", borderColor: "#faad14" }}
                                onClick={() => handleStatus(selectedUser.id, "suspended")}
                            >
                                Suspended
                            </Button>
                        )}

                        {selectedUser?.status !== "banned" && (
                            <Button
                                type="primary"
                                danger
                                onClick={() => handleStatus(selectedUser.id, "banned")}
                            >
                                Banned
                            </Button>
                        )}
                    </Space>
                </div>
            </Modal>
        </>
    );
}

export default Coach;
